module.exports = __webpack_public_path__ + "static/media/solution02@2x.26ebca14.png";